var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        { staticClass: "box-card" },
        [
          _c(
            "div",
            {
              staticClass: "clearfix",
              attrs: { slot: "header" },
              slot: "header",
            },
            [
              _c(
                "el-form",
                {
                  attrs: { inline: "", size: "small", "label-width": "120px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "执行状态" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticClass: "selWidth",
                          attrs: {
                            placeholder: "请选择",
                            size: "small",
                            clearable: "",
                          },
                          on: { change: _vm.handleList },
                          model: {
                            value: _vm.listPram.status,
                            callback: function ($$v) {
                              _vm.$set(_vm.listPram, "status", $$v)
                            },
                            expression: "listPram.status",
                          },
                        },
                        _vm._l(_vm.customersLists, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { label: item.value, value: item.id },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "创建时间：" } },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "300px" },
                        attrs: {
                          "value-format": "yyyy-MM-dd HH:mm:ss",
                          type: "datetimerange",
                          "range-separator": "-",
                          "start-placeholder": "开始日期",
                          "end-placeholder": "结束日期",
                        },
                        on: { change: _vm.handleTimerChange },
                        model: {
                          value: _vm.timer,
                          callback: function ($$v) {
                            _vm.timer = $$v
                          },
                          expression: "timer",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["admin:show-product:sync"],
                      expression: "['admin:show-product:sync']",
                    },
                  ],
                  staticClass: "mr10",
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.handleList },
                },
                [_vm._v("搜索")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["admin:show-product:sync"],
                      expression: "['admin:show-product:sync']",
                    },
                  ],
                  staticClass: "mr10",
                  attrs: { size: "small", type: "primary" },
                  on: {
                    click: function ($event) {
                      _vm.dialogAddVisible = true
                    },
                  },
                },
                [_vm._v("新增任务")]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              attrs: {
                data: _vm.listData.list,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", "min-width": "40" },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "fileName",
                  label: "上传文件名",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "totalSpu",
                  label: "SPU总数",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "totalSku",
                  label: "SKU总数",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "successSku",
                  label: "成功SKU数",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "successSpu",
                  label: "成功SPU数",
                  "min-width": "80",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "statusName",
                  label: "执行状态",
                  "min-width": "120",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "endTime",
                  label: "结束时间",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "userName",
                  label: "操作人",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "sort", label: "操作", width: "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            staticClass: "mr10",
                            attrs: { size: "small", type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.handleDalst(scope.row.id)
                              },
                            },
                          },
                          [_vm._v("查看")]
                        ),
                        _vm._v(" "),
                        scope.row.status == 21 || scope.row.status == 31
                          ? _c(
                              "el-button",
                              {
                                staticClass: "mr10",
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handlerDelete(
                                      scope.row.id,
                                      scope.row.status
                                    )
                                  },
                                },
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    scope.row.status == 21 ? "暂停" : "继续"
                                  ) + "任务"
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        scope.row.status == 22 || scope.row.status == 23
                          ? _c(
                              "el-button",
                              {
                                staticClass: "mr10",
                                attrs: { size: "small", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleGoods(scope.row.id)
                                  },
                                },
                              },
                              [_vm._v("商品完善")]
                            )
                          : _vm._e(),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c("el-pagination", {
            attrs: {
              "current-page": _vm.listPram.page,
              "page-sizes": _vm.constants.page.limit,
              layout: _vm.constants.page.layout,
              total: _vm.listData.total,
            },
            on: {
              "size-change": _vm.handleSizeChange,
              "current-change": _vm.handleCurrentChange,
            },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "新增任务",
            visible: _vm.dialogAddVisible,
            width: "35%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogAddVisible = $event
            },
          },
        },
        [
          _c(
            "el-form",
            { attrs: { "label-width": "80px" } },
            [
              _c("el-form-item", { attrs: { label: "上传文件" } }, [
                _c(
                  "div",
                  { staticStyle: { display: "flex" } },
                  [
                    _c(
                      "ButtonUploadExcel",
                      {
                        attrs: {
                          beforeUpload: function (file) {
                            return _vm.beforeUpload(file)
                          },
                        },
                      },
                      [_vm._v("上传文件")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticStyle: { "margin-left": "20px" },
                        attrs: { type: "success" },
                        on: { click: _vm.addDowExcel },
                      },
                      [_vm._v("下载模板")]
                    ),
                  ],
                  1
                ),
              ]),
              _vm._v(" "),
              _c("el-form-item", { attrs: { label: "上传文件" } }, [
                _c("div", [_vm._v("支持文件：.xlsx .xls")]),
                _vm._v(" "),
                _c("div", [_vm._v("请先导出模板在修改为您想上传商品的信息。")]),
                _vm._v(" "),
                _c("div", [
                  _vm._v("导入的文件格式请严格按照导出模版中的格式要求"),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                [
                  _c(
                    "el-button",
                    {
                      on: {
                        click: function ($event) {
                          _vm.dialogAddVisible = false
                        },
                      },
                    },
                    [_vm._v("关闭")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: { title: "查看", visible: _vm.visibility, width: "35%" },
          on: {
            "update:visible": function ($event) {
              _vm.visibility = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              staticClass: "table",
              staticStyle: { "margin-bottom": "20px" },
              attrs: {
                height: "400",
                data: _vm.detailsList,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "时间",
                  "min-width": "200",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "content", label: "内容", "min-width": "400" },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.statusNum === 21 || _vm.statusNum === 31
            ? _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "hasPermi",
                      rawName: "v-hasPermi",
                      value: ["admin:show-product:sync"],
                      expression: "['admin:show-product:sync']",
                    },
                  ],
                  staticClass: "mr10",
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.handleStoppopgetion },
                },
                [
                  _vm._v(
                    _vm._s(_vm.statusNum === 21 ? "暂停" : "继续") + "执行"
                  ),
                ]
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "el-button",
            {
              directives: [
                {
                  name: "hasPermi",
                  rawName: "v-hasPermi",
                  value: ["admin:show-product:sync"],
                  expression: "['admin:show-product:sync']",
                },
              ],
              staticClass: "mr10",
              attrs: { size: "small", type: "primary" },
              on: {
                click: function ($event) {
                  _vm.visibility = false
                },
              },
            },
            [_vm._v("关闭")]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "完善商品",
            visible: _vm.visibilitySelf,
            width: "70%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.visibilitySelf = $event
            },
          },
        },
        [
          _c(
            "el-table",
            {
              staticClass: "table",
              staticStyle: { "margin-bottom": "20px" },
              attrs: {
                "max-height": "550",
                data: _vm.detailsListSelf,
                size: "mini",
                "highlight-current-row": "",
                "header-cell-style": { fontWeight: "bold" },
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "productId",
                  label: "SPU ID",
                  "min-width": "100",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "productName",
                  label: "SPU名称",
                  "min-width": "150",
                },
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "status",
                  label: "SPU上架状态",
                  "min-width": "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            "active-value": 1,
                            "inactive-value": 0,
                            "active-text": "上架",
                            "inactive-text": "下架",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.onchangeIsShowSpu(scope.row)
                            },
                          },
                          model: {
                            value: scope.row.status,
                            callback: function ($$v) {
                              _vm.$set(scope.row, "status", $$v)
                            },
                            expression: "scope.row.status",
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "content",
                  label: "SPU图片(非必须)",
                  "min-width": "450",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticStyle: { display: "flex" } },
                          _vm._l(scope.row.images, function (item, index) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticStyle: {
                                  position: "relative",
                                  "margin-right": "10px",
                                },
                              },
                              [
                                _c("img", {
                                  staticStyle: {
                                    width: "70px",
                                    height: "70px",
                                  },
                                  attrs: { src: item },
                                }),
                                _vm._v(" "),
                                _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      position: "absolute",
                                      top: "-5px",
                                      right: "-5px",
                                      cursor: "pointer",
                                      color: "red",
                                    },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleDelete(
                                          scope.row,
                                          index
                                        )
                                      },
                                    },
                                  },
                                  [_vm._v("X")]
                                ),
                              ]
                            )
                          }),
                          0
                        ),
                        _vm._v(" "),
                        _c(
                          "el-upload",
                          {
                            staticClass: "upload-demo",
                            attrs: {
                              action: "",
                              "http-request": _vm.handleUploadForm,
                              headers: _vm.myHeaders,
                              "show-file-list": false,
                              multiple: "",
                            },
                          },
                          [
                            scope.row.images.length < 5
                              ? _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "20px" },
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleSpuId(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v("上传图片")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "SKU ID",
                  "min-width": "100",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(scope.row.skuList, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticStyle: { "margin-bottom": "40px" },
                          },
                          [_vm._v(_vm._s(item.skuId))]
                        )
                      })
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "content",
                  label: "SKU 名称",
                  "min-width": "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(scope.row.skuList, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticStyle: { "margin-bottom": "40px" },
                          },
                          [_vm._v(_vm._s(item.skuName))]
                        )
                      })
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "采销状态",
                  "min-width": "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(scope.row.skuList, function (item, index) {
                        return _c(
                          "el-select",
                          {
                            key: index,
                            staticStyle: { "margin-bottom": "30px" },
                            attrs: { size: "mini", placeholder: "" },
                            on: {
                              change: function ($event) {
                                return _vm.handleChangeStatus(item)
                              },
                            },
                            model: {
                              value: item.cpStatus,
                              callback: function ($$v) {
                                _vm.$set(item, "cpStatus", $$v)
                              },
                              expression: "item.cpStatus",
                            },
                          },
                          _vm._l(_vm.cpStatusEnum, function (item) {
                            return _c("el-option", {
                              key: item.value,
                              attrs: { label: item.label, value: item.value },
                            })
                          }),
                          1
                        )
                      })
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "content",
                  label: "SKU上架状态",
                  "min-width": "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(scope.row.skuList, function (item, index) {
                        return _c(
                          "div",
                          { key: index },
                          [
                            _c("el-switch", {
                              staticStyle: { "margin-bottom": "40px" },
                              attrs: {
                                "active-value": 1,
                                "inactive-value": 0,
                                "active-text": "显示",
                                "inactive-text": "隐藏",
                              },
                              on: {
                                change: function ($event) {
                                  return _vm.onchangeIsShowSku(item)
                                },
                              },
                              model: {
                                value: item.status,
                                callback: function ($$v) {
                                  _vm.$set(item, "status", $$v)
                                },
                                expression: "item.status",
                              },
                            }),
                          ],
                          1
                        )
                      })
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "SKU规格",
                  "min-width": "150",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(scope.row.skuList, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticStyle: { "margin-bottom": "40px" },
                          },
                          [_vm._v(_vm._s(item.attribute))]
                        )
                      })
                    },
                  },
                ]),
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "content",
                  label: "SKU 图片",
                  "min-width": "600",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return _vm._l(scope.row.skuList, function (item, index) {
                        return _c(
                          "div",
                          {
                            key: index,
                            staticStyle: { "margin-bottom": "10px" },
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { display: "flex" } },
                              _vm._l(item.skuImages, function (item1, index1) {
                                return _c(
                                  "div",
                                  {
                                    key: index1,
                                    staticStyle: {
                                      position: "relative",
                                      "margin-right": "10px",
                                    },
                                  },
                                  [
                                    _c("img", {
                                      staticStyle: {
                                        width: "70px",
                                        height: "70px",
                                      },
                                      attrs: { src: item1 },
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticStyle: {
                                          position: "absolute",
                                          top: "-5px",
                                          right: "-5px",
                                          cursor: "pointer",
                                          color: "red",
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleDelete(
                                              item,
                                              index1
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("X")]
                                    ),
                                  ]
                                )
                              }),
                              0
                            ),
                            _vm._v(" "),
                            _c(
                              "el-upload",
                              {
                                staticClass: "upload-demo",
                                attrs: {
                                  action: "",
                                  "http-request": _vm.handleUploadForm,
                                  headers: _vm.myHeaders,
                                  "show-file-list": false,
                                  multiple: "",
                                },
                              },
                              [
                                _c(
                                  "el-button",
                                  {
                                    staticStyle: { "margin-left": "20px" },
                                    attrs: { size: "mini", type: "primary" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleSkuId(item)
                                      },
                                    },
                                  },
                                  [_vm._v("上传图片")]
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      })
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }